import { TFileWithType } from '@treezor/design-system';

import { ListGroup } from '@/ui-kit/ListGroup/ListGroup';

import { useKycDocuments } from '@/features/kyc/hooks/useKycDocuments';

interface IKycDocumentSummary {
  documents: TFileWithType[];
}

export function KycDocumentSummary({ documents }: IKycDocumentSummary) {
  const { documentTranslation } = useKycDocuments();

  return (
    <ListGroup
      items={documents.map((document) => ({
        leftIcon: 'draft',
        label: document.file.name,
        itemGroupType: documentTranslation(Number(document.type)),
        actions: [
          {
            icon: 'open_in_new',
            onClick: () => window.open(URL.createObjectURL(document.file), '_blank'),
          },
        ],
      }))}
      className="w-full"
    />
  );
}
